"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const companyRegisterDataState_1 = __importDefault(require("./companyRegisterDataState"));
const react_i18next_1 = require("react-i18next");
const SellerPublishAgreeDialog_1 = __importDefault(require("@/common/components/SellerPublishAgreeDialog"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1() {
    const [showPublishAgreeDialog, setShowPublishAgreeDialog] = (0, react_1.useState)(false);
    const openPublishAgreeDialog = () => setShowPublishAgreeDialog(true);
    const closePublishAgreeDialog = () => setShowPublishAgreeDialog(false);
    const companyRegisterData = (0, recoil_1.useRecoilValue)(companyRegisterDataState_1.default);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: openPublishAgreeDialog, sx: {
                    height: '24px',
                    padding: '0 10px',
                    border: '1px solid var(--gray-10)',
                    color: 'var(--gray-80)',
                    bgcolor: 'var(--white) !important',
                } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('보기') })) })), (0, jsx_runtime_1.jsx)(SellerPublishAgreeDialog_1.default, { open: showPublishAgreeDialog, closeDialog: closePublishAgreeDialog, company_name: companyRegisterData === null || companyRegisterData === void 0 ? void 0 : companyRegisterData.company_name, company_number: companyRegisterData === null || companyRegisterData === void 0 ? void 0 : companyRegisterData.company_number })] }));
}
exports.default = default_1;
